import {ChangeDetectorRef, Component} from "@angular/core";
import {
  AbstractProdGrid,
  IProdGrid,
  MercureEvent,
  ProdGridColumnTransforms,
  ProdGridColumnType,
  ProdGridHeaderButton,
  RequestEvent,
  ResponseEvent
} from 'prod-grid';
import {GridMapService} from "../../../dip/map/grid-map.service";
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {DipColumn} from "../../../dip/dip-column";
import {DevicesService} from "../../../services/devices.service";
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {HubForm} from "./hub-form/hub-form";
import {MercureService} from "../../mercure/mercure.service";
import {MercureTopic} from "../../mercure/mercure-topic";
import {RoleService} from "../../../services/role.service";
import {Role} from "../../../dip/role";
import {Md5} from "ts-md5";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-site-detail',
  templateUrl: './site-detail.component.html'
})
export class SiteDetailComponent extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('site.hub_grid_title');
  siteSetting: string = this.translate.instant('site.details_title');
  siteSettingMap: string = this.translate.instant('site.map_title');
  isAddButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_HUB_EDIT]);
  isRemoveButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_HUB_DELETE]);
  override prodGridForm = {
    component: HubForm, style: {height: '70%', width: '60%'},
    editStyle: {height: '90%', width: '70%'}
  };
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'tag', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'hub.macAddress', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'hub.radius', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({property: 'hub.rssiPower', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({property: 'hub.latitude', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({property: 'hub.longitude', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({
      property: 'lastSeen', type: ProdGridColumnType.ICON, transform: {
        transform: ProdGridColumnTransforms.CUSTOM_FUNCTION,
        option: {function: this.lastSeenColumnTransformer, wholeRecord: false}
      }
    }),
    DipColumn.get({property: 'latLng', type: ProdGridColumnType.HIDDEN, editable: false})
  ];

  override prodGridHeaderButtons: ProdGridHeaderButton[] = [];

  constructor(protected override changeDetectorRef: ChangeDetectorRef,
              override prodGridDataService: DevicesService,
              public gridMapService: GridMapService,
              private organizationTreeSelect: OrganizationTreeSelect,
              private roleService: RoleService,
              private mercureService: MercureService,
              private translate: TranslateService) {
    super(changeDetectorRef);
    organizationTreeSelect.gridComponent = this;
  }

  private mercureSubscribe() {
    const md5 = new Md5();
    this.mercureService.subscribe(md5.appendStr(`${MercureTopic.EntityChanged}${this.organizationTreeSelect.company.id}`).end().toString()).onmessage = e => this.inputAction$.emit(new MercureEvent([]));
    this.mercureService.subscribe(md5.appendStr(`${MercureTopic.DeviceEvent}${this.organizationTreeSelect.company.id}`).end().toString()).onmessage = e => this.inputAction$.emit(new MercureEvent([]));
    this.mercureService.subscribe(md5.appendStr(`${MercureTopic.DeviceHeartbeat}${this.organizationTreeSelect.company.id}`).end().toString()).onmessage = e => this.inputAction$.emit(new MercureEvent([]));
  }

  override ngOnInit() {
    this.gridMapService.init(this);
    if (this.organizationTreeSelect.company) {
      this.mercureSubscribe();
    }
    setTimeout(() => super.ngOnInit(), 200);
  }

  ngOnDestroy(): void {
    this.mercureService.unsubscribe();
    this.organizationTreeSelect.gridComponent = null;
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    httpExtraParams = HttpExtraParams.addFilter(
      httpExtraParams,
      [
        new HttpFilterParam({property: 'deviceType.name', operator: 'eq', value: 'HUB'})
      ].concat(this.organizationTreeSelect.getHttpExtraParams(this.prodGridDataService)).filter(f => f)
    );
    super.loadProdGridData(httpExtraParams);
  }

  prodMapEvents(event) {
    this.gridMapService.prodMapEvents(event);
  }

  override outputActionEvents(event: { event: RequestEvent | ResponseEvent, value?: any }) {
    super.outputActionEvents(event);
    this.gridMapService.outputActionEvents(event);
  }

  lastSeenColumnTransformer(lastSeen) {
    if (Math.abs(+new Date() - +new Date(lastSeen)) / 1000 / 60 / 60 > 1) {
      return `<div class="heartbeat-with-check"><i class="fa fa-times text-danger"></i></div>`;
    }

    if (Math.abs(+new Date() - +new Date(lastSeen)) / 1000 < 61) {
      return `<div class="heartbeat-with-check"><i class="fa fa-heartbeat text-success" style="margin-left: 10px"></i><i class="fa fa-check info-text"></i></div>`;
    }

    return `<div class="heartbeat-with-check"><i class="fa fa-heartbeat text-success"></i></div>`;
  }
}
